// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3XDz_","rootSmall":"AddTileButton_rootSmall__MFAEw"};